export default __webpack_public_path__ + "static/media/icon-adn.18940d43.svg";